<template>
    <div>
      <div v-if="targetAudience">
        Set
      </div>
      <div v-else style="color: var(--v-darkGrayColor-base); font-weight: normal;">
        Not set
      </div>
    </div>
</template>

<script>
export default {
    name: 'ConfigPreviewTargetAudience',
    props: [
        'targetAudience',
    ],
    computed: {
    }
}
</script>

<style lang="scss" scoped>

</style>